import { useStats } from "@/api";

export function StatsHeader(): JSX.Element {
  const { data, isLoading, isError } = useStats();

  if (isLoading) {
    return <span className="text-xs text-slate-400">loading stats…</span>;
  }
  if (isError || !data) {
    return <span className="text-xs text-red-600">stats unavailable</span>;
  }

  const ageLabel =
    data.snapshot_age_seconds == null
      ? "—"
      : data.snapshot_age_seconds < 60
        ? `${Math.round(data.snapshot_age_seconds)}s`
        : `${Math.round(data.snapshot_age_seconds / 60)}m`;

  return (
    <div className="flex items-center gap-4 text-xs text-slate-600">
      <span>
        <span className="text-slate-400">chains</span>{" "}
        <strong className="text-slate-900">{data.total_chains.toLocaleString()}</strong>
      </span>
      <span>
        <span className="text-slate-400">active loads</span>{" "}
        <strong className="text-slate-900">
          {data.total_active_loads.toLocaleString()}
        </strong>
      </span>
      <span>
        <span className="text-slate-400">age</span>{" "}
        <strong className="text-slate-900">{ageLabel}</strong>
      </span>
    </div>
  );
}
